"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function xst(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.2683 17.3611L15.8795 15.9568L14.9305 13.9997L13.2683 17.3611ZM15.8844 12.0707L17.7648 15.9485L18.1205 16.6819L17.4026 17.068L12.4026 19.7569L12 19.9734L11.5974 19.7569L6.59742 17.068L5.87955 16.6819L6.23519 15.9485L8.11559 12.0707L6.23809 8.27401L5.88492 7.55983L6.57478 7.16125L11.5748 4.27231L12 4.02661L12.4253 4.27231L17.4253 7.16125L18.1151 7.55983L17.7619 8.27401L15.8844 12.0707ZM10.0085 12.0634L12 7.95639L13.9916 12.0634L12 16.0907L10.0085 12.0634ZM9.06951 13.9997L8.12049 15.9568L10.7317 17.3611L9.06951 13.9997ZM9.05455 10.1344L8.11511 8.23462L10.7 6.74111L9.05455 10.1344ZM13.3 6.74111L15.8849 8.23462L14.9455 10.1344L13.3 6.74111Z", fill: color }));
}
exports["default"] = xst;
//# sourceMappingURL=xst.js.map